import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csifelse(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# if else tutorial For Beginners</title>
 <meta name="description" content="C# if else tutorial for beginners.if else in C# is used for making a decision.If and else can be a block statement, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# if else,c# if else for,c sharp if else,c# if else for loop,end for loop c#,c# exit for loop,exit while loop c#,c# continue,if else foreach c#,c# foreach if else,c# foreach continue" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-if-else" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">If else statement in C#
</h1>
<div className="first">
        <a href="/csharp-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>



<h2 className='headings'>The syntax for if-else if in C#:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}{"\n"}
            <span className="qwerty-4">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">condition</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}
            <span className="qwerty-6">Else</span>
            {"\n"}
            <span className="qwerty-2">&#123;</span>
            {"\n"}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className='headings'>Q-Write a program to input a number and check this value is greater than 1000 or not in the CSharp(C#) tutorial?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}  {"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">if</span>
            <span className="qwerty-7">_else  </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">  int </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-2">enter a no</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">  a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">Convert </span>
            <span className="qwerty-5">.ToInt32 </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-7">ReadLine </span>
            <span className="qwerty-6">()</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-2">  If </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-1">1000</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine</span>
            <span className="qwerty-5">(</span>
              <span className="qwerty-3">"</span>
            <span className="qwerty-10">a is </span>
            <span className="qwerty-10">greater</span>
            <span className="qwerty-6"> than</span>
            <span className="qwerty-1"> 1000</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2"> else</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">a is </span>
            <span className="qwerty-10">less </span>
            <span className="qwerty-6">than </span>
            <span className="qwerty-1">1000</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-10">enter a no</span>
              {"\n"}
              <span className="qwerty-1"> 500</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-10">a is</span>
              <span className="qwerty-1"> less </span>
              <span className="qwerty-6">than</span>
              <span className="qwerty-1"> 1000</span>
              {"\n"}  {"\n"}
            </code>
          </pre>
        </div>
      </div>

<p className="mt-4 para">If you don't know about input in Csharp so check on <a href="https://www.codeexampler.com/csharp-input">C# input tutorial</a>.</p>



<h2 className='headings'>Q-Write a program to check a no is even or odd in C# Tutorial?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}  {"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">if</span>
            <span className="qwerty-7">_else  </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">  int </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-2">enter a no</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">  a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">Convert </span>
            <span className="qwerty-5">.ToInt32 </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-7">ReadLine </span>
            <span className="qwerty-6">()</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-2">  if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> % </span>
            <span className="qwerty-1">2</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-1">0</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine</span>
            <span className="qwerty-5">(</span>
              <span className="qwerty-3">"</span>
            <span className="qwerty-1">even </span>
            <span className="qwerty-6">no</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2"> else</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-1">odd </span>
            <span className="qwerty-6">no</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-10">enter a no</span>
              {"\n"}
              <span className="qwerty-1"> 42</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-6">even no</span>
              {"\n"}  {"\n"}
            </code>
          </pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program to check a no of vowels by using a character in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}  {"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">if</span>
            <span className="qwerty-7">_else  </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">  Char </span>
            <span className="qwerty-1">my_letter</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-2">enter a letter</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">  char </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">Convert</span>
            <span className="qwerty-5">.ToChar </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-7">ReadLine </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-2"> if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-1">my_letter</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-6">a</span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-3"> || </span>
            <span className="qwerty-1">my_letter</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-6">e</span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-3"> || </span>
            <span className="qwerty-1">my_letter</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-6">i</span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-3"> || </span>
            <span className="qwerty-1">my_letter</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-6">o</span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-3"> || </span>
            <span className="qwerty-1">my_letter</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-6">u</span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> use </span>
            <span className="qwerty-4">vowels</span>
            <span className="qwerty-10"> inside </span>
            <span className="qwerty-6">this </span>
            <span className="qwerty-4">character</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">else</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> no use </span>
            <span className="qwerty-4">vowels</span>
            <span className="qwerty-10"> inside </span>
            <span className="qwerty-6">this </span>
            <span className="qwerty-4">character</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-2"> enter a letter</span>
              {"\n"}
              <span className="qwerty-6"> u</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-10"> use </span>
              <span className="qwerty-4">vowels</span>
              <span className="qwerty-10"> inside </span>
              <span className="qwerty-6">this </span>
              <span className="qwerty-4">character</span>
              {"\n"}  {"\n"}
            </code>
          </pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program to find out which no is greater between two numbers in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}  {"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">if</span>
            <span className="qwerty-7">_else  </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">  int </span>
            <span className="qwerty-1">a</span>
            <span className="qwerty-10">, </span>
            <span className="qwerty-1">b</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-1">  a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-5">40</span>
            <span className="qwerty-6">;</span>
            <span className="qwerty-1"> b</span>
            <span className="qwerty-7"> = </span>
            <span className="qwerty-3">50</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">  if </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-1">a </span>
            <span className="qwerty-5">&#62; </span>
            <span className="qwerty-1">b</span>
            <span className="qwerty-4">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-1">a</span>
            <span className="qwerty-10"> is </span>
              <span className="qwerty-6">greater</span>
              <span className="qwerty-4"> = </span>
              <span className="qwerty-3">" </span>
            <span className="qwerty-10">+ </span>
              <span className="qwerty-1">a</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2">else</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-1">b</span>
            <span className="qwerty-10"> is </span>
              <span className="qwerty-6">greater</span>
              <span className="qwerty-4"> = </span>
              <span className="qwerty-3">" </span>
            <span className="qwerty-10">+ </span>
              <span className="qwerty-1">b</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"} 
              <span className="qwerty-2"> b</span>
              <span className="qwerty-6"> is </span>
              <span className="qwerty-7">greater</span>
              <span className="qwerty-10"> = </span>
              <span className="qwerty-4">50</span>
              {"\n"}  {"\n"}
            </code>
          </pre>
        </div>
      </div>

<h3 className="mt-4 mh3">Nested if list:</h3>

<h4 className="mt-4">Nested list in c# tutorial:
</h4>



<h2 className='headings'>Q-Write a program to input a no and after Check no is Greater, Less or Between in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}  {"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">if</span>
            <span className="qwerty-7">_else  </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">  int </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-2">enter a no</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">  i </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">Convert </span>
            <span className="qwerty-5">.ToInt32 </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-7">ReadLine </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-2"> if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-1">100</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">no is  </span>
            <span className="qwerty-2">less </span>
            <span className="qwerty-4">than </span>
            <span className="qwerty-1">100</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">else</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2"> if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-10"> = </span>
            <span className="qwerty-1">1000</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">greater </span>
            <span className="qwerty-4">than </span>
            <span className="qwerty-1">1000</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">else</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">between </span>
            <span className="qwerty-1">100 </span>
            <span className="qwerty-2">and </span>
            <span className="qwerty-1">1000</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-10">enter a no</span>
              {"\n"}
              <span className="qwerty-1"> 882</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-10">between</span>
              <span className="qwerty-1"> 100</span>
              <span className="qwerty-10"> and</span>
              <span className="qwerty-1"> 1000</span>
              {"\n"}  {"\n"}
            </code>
          </pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a Nested List Program in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}  {"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">if</span>
            <span className="qwerty-7">_else  </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">  char </span>
            <span className="qwerty-1">sex</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-2">who are you</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">  sex </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">Convert </span>
            <span className="qwerty-5">.ToInt32 </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-7">ReadLine </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-2"> if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-1">sex</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-6">m</span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">this is </span>
            <span className="qwerty-4">male </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">else</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2"> if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-1">sex</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-6">f</span>
            <span className="qwerty-1">'</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">this is </span>
            <span className="qwerty-4">female </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">else</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">not </span>
              <span className="qwerty-4">male </span>
              <span className="qwerty-3">and </span>
            <span className="qwerty-10">not </span>
              <span className="qwerty-4">female</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">I have checked </span>
              <span className="qwerty-6">gender</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-2"> who are you</span>
              {"\n"}
              <span className="qwerty-6"> m</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"} 
              <span className="qwerty-10"> this is </span>
              <span className="qwerty-4">male</span>
               {"\n"}
              <span className="qwerty-10"> I have checked </span>
              <span className="qwerty-6">gender</span>
              {"\n"}  {"\n"}
            </code>
          </pre>
        </div>
      </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csifelse;